export default __webpack_public_path__ + "dc5f727906accc23702542c074adca68.png";